<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
Date.prototype.Format = function (fmt) {
  let o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    "S": this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
};
Date.prototype.getQOQMonth = function () {
  if(this.getMonth() !== 0) {
    return this.getFullYear() + '-' + this.getMonth();
  }else{
    return (this.getFullYear() - 1) + '-12';
  }
};
Date.prototype.getYOYMonth = function () {
  return (this.getFullYear() - 1) + '-' + (this.getMonth() + 1);
};
export default {
  name: 'App'
}
</script>

<style>
  body{
    margin: 0;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus,
  :-webkit-autofill:active {
    -webkit-text-fill-color: #2b739d !important;
    transition: background-color 5000s ease-in-out 0s;
  }
  .zy-icon{
    text-align: left;
    width: 20px;
  }
  /*定义滚动条宽度*/
  ::-webkit-scrollbar{
    width: 10px;
    height:12px;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: rgba(0,0,0,0.1);
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: rgba(0,0,0,0.1);
  }
  .el-main{
    padding: 0;
  }
  .horizontal-menu{
    border: 0 !important;
    padding: 0 !important;
    height: 48px !important;
    line-height: 48px !important;
  }
  .horizontal-menu-item{
    border: 0 !important;
    height: 48px !important;
    line-height: 48px !important;
    text-align: center;
    font-weight: bold;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .horizontal-menu-item:hover{
    color: rgba(10, 82, 255, 1) !important;
    background: rgba(255, 255, 255, 0.2) !important;
  }
  .horizontal-menu-item.is-active{
    color: rgba(10, 82, 255, 1) !important;
    background: rgba(255, 255, 255, 0.8) !important;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 0;
  }
  .el-tree {
    background: none !important;
  }
  .el-tree >.el-tree-node {
    display: inline-block;
    min-width: 100%;
  }
  .light-blue-back-tree .el-tree-node.is-current>.el-tree-node__content {
    color: #1990FF;
    /*background-color: rgba(255,255,255,0.8);*/
  }
  .el-table, .el-table__expanded-cell {
    background-color: transparent;
  }
  .filter-search .el-input__inner{
    border: 0 !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .filter-search .el-input__inner::placeholder{
    color: #8c939d;
  }
  .search-btn-blue{
    font-size: 14px;
    width: 80px;
  }
  .aside-tree {
    height: calc(100% - 50px);
    width: 250px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue